import DatabaseReference from '../platform/DatabaseReference';
import Driver from './Driver';

export default class Drivers extends DatabaseReference {
  get childReferenceType() {
    return Driver;
  }
}
